// Module
var code = "<div class=\"four columns\"> <div ui-view=\"menu\"></div> </div> <div class=\"eight columns\"> <div ui-view></div> </div> ";
// Exports
module.exports = code;